import React from 'react';
import { useState,useEffect } from 'react';
import NavCard from '../NavCard';
import '../../styles/NavCard.css'

const Navoptionsfitness = ({fitness}) => {
    console.log("miphones",fitness);
    
    return (
        <>         
         <div className="navOptions">
         {  fitness.map((item,index)=>{  
             console.log("111111111",item)
             return(
          <NavCard name={item['name']} price={item['price']} image={item['image']} key={item['image']} index={index}></NavCard> 
             )
              })
         }

         </div>  

        </>
    )
}

export default Navoptionsfitness;
